import { createSlice } from '@reduxjs/toolkit';
import {
  wcaFetchCampaigns,
  wcaCreateNewCampaign,
  wcaFetchCampaignById,
  wcaFetchCampaignCustomers,
} from './campaign-action';

const DEFAULT_CAMPAIGN_STATE = {
  page: 0,
  limit: 30,
  campaignLoading: false,
  campaignType: 'product',
  campaignTab: 'campaign',
  campaignData: [],
  broadcastData: [],
  campaignCount: 0,
  broadcastCount: 0,
  campaignTemplates: {},
  selectedCampaignId: '',
  selectedCampaign: {},
  campCustomerPage: 0,
  campaignCustomers: [],
  stats: {
    All: 0,
    read: 0,
    sent: 0,
    replied: 0,
    ['opt-out']: 0,
    delivered: 0,
    failed: 0,
  },
  rerunCamp: false,
  mode: null,
  selectedCampaign: null,
  selectedCampaignId: 'all',
  rselectedCampaign: { id: 'all', campaignName: 'All Campaigns' },
  rselectedCampaignId: 'all',
  totalCampaignCustomersCount: 0,
};

const campaignSlice = createSlice({
  name: 'campaign',
  initialState: DEFAULT_CAMPAIGN_STATE,
  reducers: {
    changeCampaignType(state, action) {
      state.campaignType = action.payload;
      state.page = 0;
      state.selectedCampaignId = 'all';
      if (action.payload === 'product') {
        state.selectedCampaign = { id: 'all', campaignName: 'All Campaigns' };
      } else {
        state.selectedCampaign = { id: 'all', campaignName: 'All Broadcasts' };
      }
    },
    changeMode(state, action) {
      state.mode = action.payload;
    },
    resetCampaignMode(state) {
      state.mode = null;
    },
    changeCampaignTab(state, action) {
      state.campaignTab = action.payload;
      state.page = 0;
      state.limit = 10;
    },
    resetCampaignType(state) {
      state.campaignType = 'product';
      state.selectedCampaignId = 'all';
      state.selectedCampaign = { id: 'all', campaignName: 'All Campaigns' };
    },
    changePage(state, action) {
      state.page = action.payload;
    },
    changecampCustomerPage(state, action) {
      state.campCustomerPage = action.payload;
    },
    setrerunCampaign(state, action) {
      state.rerunCamp = action.payload;
    },
    rchangeSelectedCampaign(state, action) {
      state.rselectedCampaignId = action.payload.id;
      state.rselectedCampaign = action.payload;
    },
    changelimit(state, action) {
      state.limit = action.payload;
    },
    changeSelectedCampaignId(state, action) {
      if (action.payload !== 'all') {
        const campDetails = state.campaigns.filter((camp) => camp.id === action.payload);
        state.selectedCampaign = campDetails[0];
      } else {
        state.selectedCampaign = { id: 'all', campaignName: 'All Campaigns' };
      }
      state.selectedCampaignId = action.payload;
    },
    changeSelectedCampaign(state, action) {
      state.selectedCampaignId = action.payload.id;
      state.selectedCampaign = action.payload;
    },
    clearCampaignCustomers(state) {
      state.campaignCustomers = [];
    },
    resetSelectedCampaign(state) {
      state.selectedCampaignId = '';
      state.selectedCampaign = {};
    },
    resetCampaignStats(state) {
      state.stats = {
        ...DEFAULT_CAMPAIGN_STATE.stats,
      };
    },
    resetCampaignData(state) {
      state.campaignData = [];
    },
    resetCampaignPagination(state) {
      state.page = DEFAULT_CAMPAIGN_STATE.page;
      state.limit = DEFAULT_CAMPAIGN_STATE.limit;
    },
  },
  extraReducers: (builder) => {
    // Fetch Campaigns
    builder.addCase(wcaFetchCampaigns.pending, (state) => {
      state.campaignLoading = true;
      state.error = null;
    });
    builder.addCase(wcaFetchCampaigns.fulfilled, (state, action) => {
      state.campaignData = action.payload.rows;
      state.campaignCount = action.payload.count;
      state.campaignType = state.campaignTab;
      // console.log(action.payload)
      if (state.campaignType === 'product') {
        state.campaignData = action.payload.rows;
        state.campaignCount = action.payload.count;
      } else {
        state.broadcastData = action.payload.rows;
        state.broadcastCount = action.payload.count;
      }
      state.campaignLoading = false;
    });
    builder.addCase(wcaFetchCampaigns.rejected, (state, action) => {
      state.campaignLoading = false;
      state.error = action.payload;
    });

    // Create Campaign
    builder.addCase(wcaCreateNewCampaign.pending, (state) => {
      state.loading = true;
      state.error = null;
    });
    builder.addCase(wcaCreateNewCampaign.fulfilled, (state, { payload }) => {
      state.loading = false;
      // state.campaigns.unshift(payload);
      state.campaignCount += 1;
    });
    builder.addCase(wcaCreateNewCampaign.rejected, (state, { payload }) => {
      state.loading = false;
      state.error = payload;
    });

    // Fetch Campaign By ID
    builder.addCase(wcaFetchCampaignById.pending, (state) => {
      state.loading = true;
      state.error = null;
    });
    builder.addCase(wcaFetchCampaignById.fulfilled, (state, action) => {
      console.log('paylod', action.payload);
      state.campaignLoading = false;
      state.selectedCampaign = action?.payload;
      state.selectedCampaignId = action.payload?.id;
    });
    builder.addCase(wcaFetchCampaignById.rejected, (state, { payload }) => {
      state.loading = false;
      state.error = payload;
    });

    builder.addCase(wcaFetchCampaignCustomers.fulfilled, (state, { payload }) => {
      state.loading = false;
      state.campaignCustomers = [...payload.rows];
      state.totalCampaignCustomersCount = payload.count;
    });

    builder.addCase(wcaFetchCampaignCustomers.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(wcaFetchCampaignCustomers.rejected, (state) => {
      state.loading = false;
    });
  },
});

export const {
  changeSelectedCampaign,
  changePage,
  clearCampaignCustomers,
  changecampCustomerPage,
  changeSelectedCampaignId,
  resetSelectedCampaign,
  changeCampaignType,
  resetCampaignType,
  changelimit,
  setrerunCampaign,
  rchangeSelectedCampaign,
  resetCampaignStats,
  updateSelectedCampaignWithSR,
  changeCampaignTab,
  resetCampaignData,
  resetCampaignMode,
  changeMode,
  resetCampaignPagination,
} = campaignSlice.actions;
export default campaignSlice.reducer;
